module.exports = __webpack_public_path__ + "static/media/Sep_2025_1.c0e06557.webp";